import { EPageTypeGetParam } from '@/enums/EPageTypeGetParam';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_grid2d_slug_offset_set_to_url } from '@/pages/_base/grid2d/_hooks/use_grid2d_slug_offset_set_to_url';
import { UTILS__url } from '@/utils/UTILS__url';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { MutableRefObject } from 'react';

interface Props {
  grid2d: DTO__grid2d;
  grid2d_virtual: DTO__grid2d_virtual;
  set_slug_offset: (value: number) => void;
  is_first_scroll_done: boolean;
  ref_first_image_index_on_page: MutableRefObject<number>;
  slug_offset: number;
}

export function WATCHER_GRID2D_FLOAT__slug({ grid2d_virtual, is_first_scroll_done, set_slug_offset, ref_first_image_index_on_page, slug_offset }: Props) {
  const set_param_grid2d_offset_to_url = use_grid2d_slug_offset_set_to_url();

  /*
   * EFFECTS
   */
  use_effect(() => {
    return () => void UTILS__url.delete(EPageTypeGetParam.GRID2D_OFFSET);
  }, []);

  //? deps: grid2d_virtual.grid2d_total_cells_amount
  use_effect(() => {
    const param = UTILS__url.get(EPageTypeGetParam.GRID2D_OFFSET);

    const total_images = grid2d_virtual.cells__amount__grid2d_total;

    const is_valid_number = /^\d+$/.test(param);

    let offset_new = is_valid_number ? Number(param) : NaN;

    if (isNaN(offset_new) || offset_new > total_images || offset_new < 0) {
      offset_new = 0;
      set_param_grid2d_offset_to_url(offset_new);
    }

    if (slug_offset === offset_new) return;

    set_slug_offset(offset_new);
  }, []);

  use_effect(() => {
    if (!is_first_scroll_done) return;

    let offset_new = ref_first_image_index_on_page.current;

    if (slug_offset === offset_new) return;

    set_param_grid2d_offset_to_url(offset_new);
    set_slug_offset(offset_new);
  }, [ref_first_image_index_on_page.current, is_first_scroll_done]);

  return null;
}
